<template>
  <div class="personalinfo-right">
    <h3>个人账户信息</h3>
    <div class="head">
      <span class="account-info">详细资料</span>
    </div>
    <div class="details">
      <div class="box">
        <p>
       <span>*</span>   邮箱
        </p>
        {{forData.email}}
      </div>
      <div class="box">
        <p>
         <span>*</span> 真实姓名
        </p>
        <input type="text" v-model="forData.username" />
      </div>
      <div class="box">
        <p>
       <span>*</span>   客户状态
        </p>
        <div>
           <span>{{ ["待激活", "已激活", "待审核",'已审核','审核不通过',"已锁定"][forData.status] }}</span>
        </div>
      </div>
      <div class="default">
        <p>
       <span>*</span>   性别
        </p>
        <div>
          <el-radio v-model="forData.sex" :label="0">男</el-radio>
          <el-radio v-model="forData.sex" :label="1">女</el-radio>
        </div>
      </div>
      <div class="box">
        <p>
         <span>*</span> 手机号码
        </p>
        <input type="text" v-model="forData.mobile" />
      </div>     
      <div class="box">
        <p>
         <span>*</span> 单位名称
        </p>
        <span v-if="forData.status == 3">{{forData.company}}</span>
        <input v-else type="text" v-model="forData.company" />
      </div>
      <div class="select">
        <p>
         <span>*</span> 选择地区
        </p>
        <div>
          <el-cascader
            v-model="district"
            :props="props"
            @change="handleChange"
            clearable
          ></el-cascader>
        </div>
      </div>
      <div class="box">
        <p>
         <span>*</span> 单位地址
        </p>
        <input type="text" v-model="forData.address" />
      </div>
      <div class="box">
        <p>邮编</p>
        <input type="text" v-model="forData.postcode" />
      </div>
      <div class="box">
        <p>固定电话</p>
        <input type="text" v-model="forData.phone" />
      </div>
      <div class="box">
        <p>传真</p>
        <input type="text" v-model="forData.fax" />
      </div>
      <div class="box">
        <button @click="save">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let _self = this;
    return {
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      imageUrl: "",
      flag: false,
      forData: {
        username: "",
        sex: 0,
        mobile: "",
        company: "",
        province_code: "",
        city_code: "",
        district_code: "",
        address: "",
        postcode: "",
        phone: "",
        fax: ""
      },
      disabled: true,
      district: [],
      statusFlag: false,
      props: {
        lazy: true,
        lazyLoad: this.cascaderDistrict
      }
    };
  },
  methods: {
    cascaderDistrict(node, resolve) {
      const { level } = node;
      const { data } = node;
      let parentCode = data ? data.value : "0";
      this.$api.address
        .district({
          code: parentCode
        })
        .then(res => {
          const nodes = res.data.map(item => ({
            value: item.adcode,
            label: item.name,
            leaf: level >= 2
          }));
          resolve(nodes);
        });
    },
    handleChange(value) {
      (this.forData.province_code = value[0]),
        (this.forData.city_code = value[1]),
        (this.forData.district_code = value[2]);
    },
    save() {
      this.$api.personalInfo
        .changeUserinfo({
          ...this.forData
        })
        .then(res => {
          if (res.status == 1) {
            this.changeStatus = false;
            this.disabled = true;
            this.$message.closeAll();
            this.$message.success('保存信息成功')
          } else {
            this.$message.closeAll();
            this.$message.warning(res.msg);
          }
        });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    }
  },
  created() {
    this.$api.personalInfo.getuser({}).then(res => {
      if (res.status == 1) {
        this.forData = res.data;
        this.district = [
          res.data.province_code,
          res.data.city_code,
          res.data.district_code
        ];
      } else {
        this.$message.closeAll();
        this.$message.warning(res.msg);
      }
    });
  }
};
</script>

<style lang="less" scoped>
* {
  font-size: 16px;
}
input {
  padding-left: 5px;
}
.personalinfo-right {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #333333;
  h3 {
    font-size: 24px;
    text-align: left;
    color: #333333;
    margin-bottom: 20px;
  }
  .head {
    width: 876px;
    height: 38px;
    background: #f5f5f5;
    border: 1px solid #dddddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .account-info {
      font-size: 14px;
      color: #333333;
      margin-left: 17px;
    }
    .edit {
      font-size: 14px;
      color: #666666;
      margin-right: 24px;
      cursor: pointer;
    }
    .edit:hover {
      color: #ffbb00;
    }
  }
  .basicinfo {
    width: 876px;
    height: 130px;
    border: 1px solid #dddddd;
    display: flex;
    margin-bottom: 29px;
    .b-left {
      width: 513px;
      height: 100%;
      input {
        width: 400px;
        height: 30px;
        background: #ffffff;
        border: 1px solid #dddddd;
        border-radius: 3px;
        margin-left: 15px;
        &.username-input {
          margin-top: 32px;
        }
        &.eamil-input {
          margin-top: 7px;
        }
      }
      span {
        width: 44px;
        height: 19px;
        font-size: 14px;
        &.username {
          margin-left: 54px;
          margin-top: 37px;
        }
        &.eamil {
          margin-left: 68px;
          margin-top: 18px;
        }
      }
    }
    .b-right {
      display: flex;
      .el-row {
        margin-top: 30px;
        margin-left: 118px;
      }
      img {
        width: 70px;
        height: 70px;
      }
      i {
        width: 58px;
        height: 19px;
        font-size: 14px;
        text-decoration: underline;
        text-align: left;
        color: #333333;
        font-style: normal;
      }
      .avatar-uploader {
        margin-top: 44px;
        margin-left: 28px;
      }
    }
  }
  .details {
    width: 876px;
    min-height: 500px;
    border: 1px solid #dddddd;
    .default {
      height: 30px;
      width: 620px;
      margin: 20px 55px 20px 46px;
      display: flex;
      p {
        width: 100px;
        height: 24px;
        color: #000;
        margin-right: 16px;
        text-align: right;
        line-height: 30px;
        span {
          color: #f56c6c;
          margin-right: 5px;
          margin-bottom: 3px;
        }
      }
      div {
        margin-right: 40px;
      }
      input {
        margin-right: 7px;
      }
      span {
        color: #666666;
        line-height: 24px;
      }
    }
    .select {
      height: 30px;
      width: 620px;
      margin: 20px 55px 20px 46px;
      display: flex;
      p {
        width: 100px;
        height: 24px;
        color: #000;
        margin-right: 16px;
        text-align: right;
        line-height: 30px;
        span {
          color: red;
          margin-left: 3px;
        }
      }
      div {
        /deep/.el-input__inner {
          width: 422px;
          height: 30px;
          background: #ffffff;
          border-radius: 3px;
          border: 0px;
          border: 1px solid #dddddd;
        }
      }
    }
    .box {
      height: 30px;
      width: 620px;
      margin: 20px 55px 20px 46px;
      display: flex;
      p {
        width: 100px;
        height: 24px;
        color: #000;
        margin-right: 16px;
        text-align: right;
        span {
          color: red;
          margin-left: 3px;
        }
      }
      input {
        width: 422px;
        height: 30px;
        background: #ffffff;
        border-radius: 3px;
        border: 0px;
        border: 1px solid #dddddd;
      }
      button{
        width: 120px;
        height:40px;
        border:0px;
        background: #003871;
        color:#fff;
        margin: auto;
        font-size: 16px;
      }
    }
  }
}
</style>